import { Injectable } from '@angular/core';
import { Validators, UntypedFormGroup } from '@angular/forms';
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { DataService } from '../../services/data/data.service';


@Injectable()

export class ValidationService {

	// add all patterns here
	private emailpattern = '[a-zA-Z0-9.%+-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}';
	// check for only alphabets.
	private namepattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\" ]+';
	// Date forma YYYY-MM-DD
	private datepattern = '(19[5-9][0-9]|2[0-9][0-9][0-9])[-](0+[1-9]|1[0-2])[-](0[1-9]|[12][0-9]|3[01])';
	//
	private string1to3pattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,3}';
	//
	private alphanumeric3pattern = '[a-zA-Z0-9]{3}';
	// string of length 1 to 6
	private string1to6pattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,6}';
	// string of exactly 6 characters
	private string6pattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{6}';
	// groupid,controlgroupcode
	private string1to8pattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,8}';
	//
	private string1to20pattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,20}';
	// adjreasoncode
	private adjreasoncodepattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,2}';

	// paymentdays,quantity
	private numberpattern = '[0-9]{1,4}';

	// country code, string of exactly 3 digits
	private number3pattern = '[0-9]{3}';

	private workitemidpattern = '[a-zA-Z0-9_!@#$&()\\-`.+,/\"]{8}';

	private activitycodeidpattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,6}';

	private activitydescidpattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\" ]{1,20}';

	private billcodeidpattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,3}';
	// Site Location
	private sitelocationpattern = '[a-z0-9!@#$&()\\-`.+,/\"A-Z ]{1,8}';

	// Country code string 3 digits minlenth =1 and maxlength = 3
	// private countrycodepattern = '[a-zA-Z0-9!@#$&()\\-`.+,/\"]{1,3}';
	// Company code String minlength = 1 and max length = 8 only capital letters
	// private companycodepattern = '[0-9a-zA-Z!@#$&()\\-`.+,/\"]{1,8}';

	isValid(form, itemProp) {
		// console.log('CHECK VALID', itemProp, form);
		const control = form.form.controls[itemProp];
		let isValid = true;
		if (control !== undefined) {
			if (control.invalid && control.touched) {
				isValid = false;
			}
		}
		return isValid;
	}

	isChanged(form, itemProp) {
		const control = form.form.controls[itemProp];
		// console.log('CHECK CHANGED', itemProp, control);
		let isChanged = false;
		if (control !== undefined) {
			if (control.touched && !control.pristine) {
				isChanged = true;
			}
		}
		return isChanged;
	}

	isRequiredError(form, prop) {
		const control = form.form.controls[prop];
		let isRequiredError = false;
		try {
			if (control.errors.required && control.touched) {
				isRequiredError = true;
			}
		} catch (e) { }
		return isRequiredError;
	}

	isPatternError(form, prop) {
		const control = form.form.controls[prop];
		let isPatternError = false;
		try {
			if (control.errors.pattern && control.touched) {
				isPatternError = true;
			}
			if (control.errors.min && control.touched) {
				isPatternError = true;
			}
			if (control.errors.max && control.touched) {
				isPatternError = true;
			}
		} catch (e) { }
		return isPatternError;
	}

	isOutOfRangeError(form, prop) {
		const control = form.form.controls[prop];
		let isOutOfRangeError = false;
		try {
			if (control.errors.min && control.touched) {
				isOutOfRangeError = true;
			}
			if (control.errors.max && control.touched) {
				isOutOfRangeError = true;
			}
		} catch (e) { }
		return isOutOfRangeError;
	}

	isMismatchError(form, prop) {
		const control = form.form.controls[prop];
		let isMismatchError = false;
		try {
			if (control.errors.validatePassword && control.touched) {
				isMismatchError = true;
			}
		} catch (e) { }
		return isMismatchError;
	}

	applyControlProps(config, group): UntypedFormGroup {
		for (const key in group.controls) {
			if (group.controls.hasOwnProperty(key)) {
				config.fields.forEach(function (d, i) {
					if (key === d.prop) {
						console.log('SET CONTROL PROP', key, d.prop);
						group.controls[key]['prop'] = d.prop;
					}
				});
				config.objects.forEach(object => {
					object.fields.forEach(function (d, i) {
						if (key === d.prop) {
							console.log('SET CONTROL PROP', key, d.prop);
							group.controls[key]['prop'] = d.prop;
						}
					});
				});
			}
		}
		console.log('APPLY CONTROL PROPS', group);
		return group;
	}

	applyValidation(config, forceEdits) {
		const validations = {};
		config.fields.forEach(item => {
			if (item.edit || forceEdits) {
				validations[item.prop] = this.prepareValidators(item);
			}
		});

		config.objects.forEach(object => {
			object.fields.forEach(item => {
				if (item.edit || forceEdits) {
					validations[item.prop] = this.prepareValidators(item);
				}
			});
		});

		console.log('APPLIED VALIDATIONS', validations);
		return validations;
	}

	prepareValidators(item): Array<Validators> {
		const validator: any = [];
		validator.push('');

		const patterns: any = [];
		if (item.required) {
			patterns.push(Validators.required);
		}
		if (item.validate !== '') {
			const validations = item.validate.split(',');
			validations.forEach(validation => {
				patterns.push(Validators.pattern(this.getPattern(validation)));
			});
		}
		if (item.minVal !== '') {
			patterns.push(Validators.min(item.minVal));
		}
		if (item.maxVal !== '') {
			patterns.push(Validators.max(item.maxVal));
		}
		if (patterns.length > 0) {
			validator.push(Validators.compose(patterns));
		}

		return validator;
	}

	getPattern(validationType) {
		switch (validationType) {
			case 'email':
				return this.emailpattern;
			case 'date':
				return this.datepattern;
			case 'name':
				return this.namepattern;
			case 'number':
				return this.numberpattern;
			case 'countrycodeValid':
				return this.billcodeidpattern;
			case 'companycodeValid':
				return this.string1to8pattern;
			case 'sitelocationValid':
				return this.sitelocationpattern;
			case 'string1to3':
				return this.string1to3pattern;
			case 'string1to6':
				return this.string1to6pattern;
			case 'alphanumeric3':
				return this.alphanumeric3pattern;
			case 'string6':
				return this.string6pattern;
			case 'number3':
				return this.number3pattern;
			case 'string1to8':
				return this.string1to8pattern;
			case 'string1to20':
				return this.string1to20pattern;
			case 'adjreasoncodevalid':
				return this.adjreasoncodepattern;
			case 'workitemid':
				return this.workitemidpattern;
			case 'groupid':
				return this.string1to8pattern;
			case 'activitycodeid':
				return this.activitycodeidpattern;
			case 'activitydescid':
				return this.activitydescidpattern;
			case 'billcodeid':
				return this.billcodeidpattern;
			default:
				return '';
		}
	}
}

@Directive({
	selector: '[pcmPasswordValidator]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => PasswordValidatorDirective), multi: true }
	]
})

export class PasswordValidatorDirective {

	validator: Function;

	constructor() {
		this.validator = this.validateControl();
	}

	validate(c: UntypedFormControl) {
		return this.validator(c);
	}

	validateControl() {
		return (c: UntypedFormControl) => {

			// console.log('FORM CONTROL', c);

			let controlField;

			c.parent['config'].forEach(function (d, i) {
				if (c['prop'] === d.prop) {
					controlField = d;
				}
			});

			// console.log('FORM CONTROL', c, controlField);

			const shouldMatch = controlField.requiredIf;
			const matchControl = c.root.get(shouldMatch);
			const matchValue = matchControl.value;

			// console.log('VALIDATE PASSWORD', c['prop'], c.value, shouldMatch, matchControl, matchValue);

			if (c.value === matchValue) {
				// console.log('PASSWORD VALUES MATCH');
				// if (shouldMatch === 'passwordConfirm') {
				if (matchControl.errors !== undefined && matchControl.errors !== null) {
					if (matchControl.errors['validatePassword'] !== undefined) {
						delete matchControl.errors['validatePassword'];
					}
					if (!Object.keys(matchControl.errors).length) {
						matchControl.setErrors(null);
					}
				}
				return null;
				// }
			} else {
				// console.log('PASSWORD VALUES DONT MATCH');
				matchControl.setErrors({ validatePassword: { valid: false } });
				return { validatePassword: { valid: false } };
			}


		};
	}
}

